import { Link } from "react-router-dom";

export const AuthShell = ({ title, subtitle, children }) => (
  <div className="min-h-screen flex items-center justify-center p-6 bg-background font-body">
    <div className="w-full max-w-md animate-in-up">
      <Link to="/login" className="flex items-center gap-2 mb-8" data-testid="auth-shell-brand-link">
        <div className="w-10 h-10 rounded-lg bg-white overflow-hidden flex items-center justify-center border border-border">
          <img src="/logo.jpg" alt="Skanovix logo" className="w-full h-full object-cover" />
        </div>
        <span className="font-heading font-extrabold text-lg">Skanovix HRMS</span>
      </Link>
      <h1 className="font-heading text-3xl font-extrabold tracking-tight">{title}</h1>
      <p className="text-muted-foreground mt-1 mb-8">{subtitle}</p>
      {children}
    </div>
  </div>
);
